import {
  GetConfigFinalInterviewDimensionsResponse,
  UpdateFinalInterviewDimensionsConfig,
} from "../../../types/api/configurations.type";
import httpClient from "../../client/HttpClient";

const ConfigurationsFinalInterviewDimensionsService = {
  async list(): Promise<GetConfigFinalInterviewDimensionsResponse> {
    const response =
      await httpClient.get<GetConfigFinalInterviewDimensionsResponse>(
        "v1/config/final-interview/dimensions",
      );
    return response;
  },
  async update(body: UpdateFinalInterviewDimensionsConfig): Promise<void> {
    await httpClient.patch("v1/config/final-interview/dimensions", body);
  },
};

export default ConfigurationsFinalInterviewDimensionsService;
